@if (!!imageUrl) {
  <div #canvascontainer class="canvas-container"  [ngClass]="{'hide-canvas': weHaveNoImage}">
    <wm-canvas #canvas></wm-canvas>
  </div>
}
@if (!imageUrl) {
  <div class="wm-spinner-centered">
    <p-progressSpinner></p-progressSpinner>
    <div class="wm-spinnerlabel">Loading...</div>
  </div>
}
@if (weHaveNoImage) {
  <div class="wm-stateview-noscreenshot">
    <div class="wm-statesummary-error-icon">
      <fa-icon [icon]="faQuestionCircle"></fa-icon>
    </div>
    <span>Screenshot unavailable</span>
  </div>
}
